// extracted by mini-css-extract-plugin
module.exports = {"lds-facebook":"bars_loader_lds-facebook__23Nlt"};